//#region ../schema-sql-parser/dist/parser/tokenizer.js
var TokenType = {
	string: "string",
	leftParent: "leftParent",
	rightParent: "rightParent",
	leftBracket: "leftBracket",
	rightBracket: "rightBracket",
	comma: "comma",
	period: "period",
	equal: "equal",
	semicolon: "semicolon"
};
var pattern = {
	doubleQuote: `"`,
	dash: "-",
	slash: "/",
	asterisk: "*",
	newLine: "\n",
	singleQuote: `'`,
	backtick: "`",
	whiteSpace: /\s/,
	string: /\S/,
	breakString: /;|,|\(|\)|\[|\]|\.|=/,
	literalEnd: /[\s,;)\]:|+]/,
	equal: "=",
	period: ".",
	comma: ",",
	semicolon: ";",
	leftParent: "(",
	rightParent: ")",
	leftBracket: "[",
	rightBracket: "]"
};
var SparkEscapes = {
	"0": "\0",
	b: "\b",
	n: "\n",
	r: "\r",
	t: "	",
	Z: "",
	"%": "\\%",
	_: "\\_"
};
var fromSparkCodePoint = (codePoint) => codePoint < 65536 ? String.fromCharCode(codePoint) : String.fromCharCode(Math.floor((codePoint - 65536) / 1024) + 55296, (codePoint - 65536) % 1024 + 56320);
var readSparkEscape = (rest) => {
	const unicode = /^(?:u([\da-fA-F]{4})|U([\da-fA-F]{8}))/.exec(rest);
	if (unicode) {
		const hex = unicode[1] ?? unicode[2];
		return [fromSparkCodePoint(parseInt(hex, 16)), hex.length + 1];
	}
	const octal = /^[01][0-7]{2}/.exec(rest);
	if (octal) return [String.fromCharCode(parseInt(octal[0], 8)), 3];
	if (!rest) return ["\\", 0];
	return [SparkEscapes[rest[0]] ?? rest[0], 1];
};
var PREFIX = String.raw`(?:[nebx]|u&|_[a-z\d]+)`;
var OPERATOR = String.raw`[+\-*/%|<>!^~#@?]`;
var OPENS_LITERAL = new RegExp(String.raw`(?:(?:^|${OPERATOR})${PREFIX}|${OPERATOR})$`, "i");
var GLUED_LITERAL = new RegExp(String.raw`^(.*?)(${OPERATOR}*)(${PREFIX}?)$`, "is");
var createEqual = (type) => (char) => type === char;
var createTest = (regexp) => (char) => regexp.test(char);
var match = {
	doubleQuote: createEqual(pattern.doubleQuote),
	dash: createEqual(pattern.dash),
	slash: createEqual(pattern.slash),
	asterisk: createEqual(pattern.asterisk),
	newLine: createEqual(pattern.newLine),
	singleQuote: createEqual(pattern.singleQuote),
	backtick: createEqual(pattern.backtick),
	whiteSpace: createTest(pattern.whiteSpace),
	string: createTest(pattern.string),
	breakString: createTest(pattern.breakString),
	literalEnd: createTest(pattern.literalEnd),
	equal: createEqual(pattern.equal),
	period: createEqual(pattern.period),
	comma: createEqual(pattern.comma),
	semicolon: createEqual(pattern.semicolon),
	leftParent: createEqual(pattern.leftParent),
	rightParent: createEqual(pattern.rightParent),
	leftBracket: createEqual(pattern.leftBracket),
	rightBracket: createEqual(pattern.rightBracket)
};
function tokenizer(source, database) {
	const tokens = [];
	const spark = database === "Databricks";
	let pos = 0;
	const isChar = () => pos < source.length;
	const isEscapedQuote = (value) => {
		if (pos + 1 >= source.length || match.literalEnd(source[pos + 1])) return false;
		let run = 0;
		while (value[value.length - 1 - run] === "\\") run++;
		return run % 2 === 1;
	};
	const readQuoted = (quote, prefix) => {
		const close = quote === "[" ? "]" : quote;
		let value = "";
		pos++;
		while (isChar()) {
			const char = source[pos];
			if (spark && quote === "'" && char === "\\") {
				const [text, length] = readSparkEscape(source.slice(pos + 1, pos + 10));
				value += text;
				pos += length + 1;
				continue;
			}
			if (char === close && quote === "'" && !spark && isEscapedQuote(value)) value = value.slice(0, -1);
			else if (char === close) {
				if (quote === "[" || source[pos + 1] !== close) break;
				pos++;
			}
			value += char;
			pos++;
		}
		tokens.push({
			type: TokenType.string,
			value,
			quoted: quote,
			...prefix ? { prefix } : {}
		});
		pos++;
	};
	while (isChar()) {
		let char = source[pos];
		if (match.whiteSpace(char)) {
			let value = "";
			while (isChar() && match.whiteSpace(char)) {
				value += char;
				char = source[++pos];
			}
			continue;
		}
		if (match.dash(char) && match.dash(source[pos + 1])) {
			while (isChar() && !match.newLine(char)) char = source[++pos];
			continue;
		}
		if (match.slash(char) && match.asterisk(source[pos + 1])) {
			pos += 2;
			char = source[pos];
			while (isChar() && !(match.asterisk(char) && match.slash(source[pos + 1]))) char = source[++pos];
			pos += 2;
			continue;
		}
		if (match.leftParent(char)) {
			tokens.push({
				type: TokenType.leftParent,
				value: char
			});
			pos++;
			continue;
		}
		if (match.rightParent(char)) {
			tokens.push({
				type: TokenType.rightParent,
				value: char
			});
			pos++;
			continue;
		}
		if (match.comma(char)) {
			tokens.push({
				type: TokenType.comma,
				value: char
			});
			pos++;
			continue;
		}
		if (match.period(char)) {
			tokens.push({
				type: TokenType.period,
				value: char
			});
			pos++;
			continue;
		}
		if (match.equal(char)) {
			tokens.push({
				type: TokenType.equal,
				value: char
			});
			pos++;
			continue;
		}
		if (match.semicolon(char)) {
			tokens.push({
				type: TokenType.semicolon,
				value: char
			});
			pos++;
			continue;
		}
		if (match.rightBracket(char)) {
			tokens.push({
				type: TokenType.rightBracket,
				value: char
			});
			pos++;
			continue;
		}
		if (match.leftBracket(char)) {
			readQuoted("[");
			continue;
		}
		if (match.doubleQuote(char)) {
			readQuoted("\"");
			continue;
		}
		if (match.singleQuote(char)) {
			readQuoted("'");
			continue;
		}
		if (match.backtick(char)) {
			readQuoted("`");
			continue;
		}
		if (match.string(char)) {
			let value = "";
			while (isChar() && match.string(char) && !match.breakString(char) && !(match.dash(char) && match.dash(source[pos + 1])) && !(match.slash(char) && match.asterisk(source[pos + 1])) && !(match.singleQuote(char) && OPENS_LITERAL.test(value))) {
				value += char;
				char = source[++pos];
			}
			if (!match.singleQuote(char)) {
				tokens.push({
					type: TokenType.string,
					value
				});
				continue;
			}
			const [, head, operator, prefix] = GLUED_LITERAL.exec(value);
			for (const word of [head, operator]) if (word) tokens.push({
				type: TokenType.string,
				value: word
			});
			readQuoted("'", prefix);
			continue;
		}
		pos++;
	}
	return tokens;
}
//#endregion
export { TokenType, tokenizer };
